import { z } from "zod";

const paymentModeValues = [
  "CARD",
  "CHEQUE",
  "CASH",
  "CREDIT",
  "ONLINE_PAYMENT",
  "MIXED",
] as const;

const PurchaseEntryProductSchema = z.object({
  id: z.number().optional().default(0),
  productId: z.number(),
  quantity: z.number(),
  unitPrice: z.number(),
  tax: z.number(),
  discount: z.number(),
  expiryDate: z.string(),
  isDiscountPercentage: z.boolean(),
  unit: z.string(),
  conversionToBaseUnit: z.number(),
  baseQuantity: z.number(),
});

export const PurchaseSchema = z.object({
  id: z.number().optional().default(0),
  purchaseNumber: z.string().trim().min(1, "Purchase number is required"),
  vendorId: z.number().min(1, "Vendor is required"),
  vendorName: z.string().min(1, "Vendor name is required"),
  // amountPaid: z.string().optional(),
  amountPaid: z.number().min(0, "Amount paid must be at least 0"),

  purchaseEntryProductRequests: z.array(PurchaseEntryProductSchema),
  attachment: z.string().optional(),
  purchaseDate: z.string().min(1, "Purchase date is required"),
  paymentMode: z.enum(paymentModeValues).default("CASH"),
  chqNumber: z.string().optional(),
  cardNumber: z.string().optional(),
  onlinePaymentRefNo: z.string().optional(),
});

export type PurchaseSchemaT = z.infer<typeof PurchaseSchema>;
